<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p>港口名称：</p>
        <el-input v-model='port' size='mini' style='width:150px' placeholder='请输入港口名称' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>批次号：</p>
        <el-input v-model='batchIpt' size='mini' style='width:150px' placeholder='请输入批次号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>运单号：</p>
        <el-input v-model='awbIpt' size='mini' style='width:150px' placeholder='请输入运单号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>车架号：</p>
        <el-input v-model='chassisIpt' size='mini' style='width:150px' placeholder='请输入车架号'
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'chassisIpt')}" />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>品牌：</p>
        <el-input v-model='brandIpt' size='mini' style='width:150px' placeholder='请输入品牌' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>进港扫码人：</p>
        <el-input v-model='enterPort' size='mini' style='width:150px' placeholder='请输入进港扫码人' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>出港扫码人：</p>
        <el-input v-model='outPort' size='mini' style='width:150px' placeholder='请输入出港扫码人' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>状态：</p>
        <el-select v-model='state' style='width:150px' size='mini' filterable clearable
                   placeholder='请选择状态'>
          <el-option v-for='item in stateOption' :key='item.val' :label='item.name'
                     :value='item.val'></el-option>
        </el-select>
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>作业时间：</p>
        <el-date-picker v-model='enterPortDate' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='outPortDate' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='结束日期' />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <span class='pointer' @click='downLoad'>下载模板</span>
          <span style='cursor: pointer;margin-right: 5px;'>
              <el-upload
                ref='upload'
                class='upload-demo'
                :action='uploadUrl'
                :auto-upload='true'
                :show-file-list='false'
                :data='uploadData'
                :on-success='planOnSuccess'
                :before-upload='beforeUpload'
              >
                <i class='el-icon-upload el-icon--right'>表格导入</i>
              </el-upload>
          </span>
          <span class='pointer' @click='exportData'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <!-- <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column> -->
          <el-table-column prop='portName' label='港口名称' align='center' />
          <el-table-column prop='batchNumber' label='批次号' align='center' />
          <el-table-column prop='waybillNo' label='运单编号' align='center' />
          <el-table-column prop='frameNumber' label='车架号' align='center' />
          <el-table-column prop='brandName' label='品牌' align='center' />
          <el-table-column prop='modelName' label='型号' align='center' />
          <el-table-column label='进港类型' align='center'>
            <div slot-scope='scope'>{{ getType(scope.row.enterPortType) }}</div>
          </el-table-column>
          <el-table-column label='进港时间' align='center' width='130'>
            <!-- <div slot-scope='scope'>{{ getTime(scope.row.enterPortDate) }}</div> -->
            <div slot-scope='scope'>{{ scope.row.enterPortDate }}</div>
          </el-table-column>
          <el-table-column prop='enterPortPeople' label='进港扫码人' align='center' />
          <el-table-column label='出港时间' align='center' width='130'>
            <!-- <div slot-scope='scope'>{{ getTime(scope.row.outPortDate) }}</div> -->
            <div slot-scope='scope'>{{ scope.row.outPortDate }}</div>
          </el-table-column>
          <el-table-column prop='outPortPeople' label='出港扫码人' align='center' />
          <el-table-column label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.state) }}</div>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {
    vehicleDeployInfoCvPortList,
    vehicleDeployInfoCvportFocusPageList,
  } from '@/service/vehiclelog';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { baseUrl } from '@/config/env';

  export default {
    data() {
      return {
        importLoading: false,
        port: '',   // 港口名称
        batchIpt: '',  // 批次号
        awbIpt: '',   // 运单号
        chassisIpt: '',  // 车架号
        brandIpt: '',   // 品牌
        enterPort: '',   // 进港扫码人
        outPort: '',   // 出港扫码人
        enterPortDate: '', // 进港时间
        outPortDate: '', // 出港时间
        state: '',   // 状态
        stateOption: [{
          name: '全部',
          val: '',
        }, {
          name: '已进港',
          val: '0',
        }, {
          name: '已出港',
          val: '1',
        }],
        center: '',//委托车当前位置
        lineArr: '',//委托车路线
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        // 批量导入
        uploadUrl: '',  // 导入路径
        uploadData: {
          mFile: '',
        },
      };
    },
    computed: {
      getState() {
        return function(state) {
          switch (state) {
            case 0:
              return '已进港';
            case 1:
              return '已出港';
          }
        };
      },
      getType() {
        return function(state) {
          switch (state) {
            case 0:
              return '起始进港';
            case 1:
              return '司机交车进港';
            case 2:
              return '船舶交车进港';
          }
        };
      },
    },
    mounted() {
     // this._vehicleDeployInfoCvPortList();
      // let token = getSessionStore('token');
      // this.uploadUrl  = baseUrl +`/platform/entryPort/entryPortExcel?access_token=${token}`
      this.uploadUrl = getImportUrl('/portFocusManage/importAddFocus');
    },
    methods: {
      // 结束时间
      dateChange(val) {
        if (this.outPortDate && this.enterPortDate && (this.outPortDate < this.enterPortDate)) {
          if (val === this.outPortDate) this.outPortDate = '';
          if (val === this.enterPortDate) this.enterPortDate = '';
          return this.$message.warning('结束日期必须大于等于开始日期！');
        }
      },
      // 获取页面表格数据
      async _vehicleDeployInfoCvPortList() {
        this.tableLoad = true;
        let res = null;
        if (this.chassisIpt.length < 200) {//GET
          res = await vehicleDeployInfoCvPortList(
            {
              portName: this.port,
              waybillNo: this.awbIpt,
              batchNumber: this.batchIpt,
              frameNumber: this.chassisIpt,
              brandName: this.brandIpt,
              enterPortPeople: this.enterPort,
              outPortPeople: this.outPort,
              startTime: this.enterPortDate || '',
              endTime: this.outPortDate || '',
              state: this.state,
              rows: this.size,
              page: this.page,
            },
          );
        } else {//POST
          res = await vehicleDeployInfoCvportFocusPageList(
            {
              portName: this.port,
              waybillNo: this.awbIpt,
              batchNumber: this.batchIpt,
              frameNumber: this.chassisIpt,
              brandName: this.brandIpt,
              enterPortPeople: this.enterPort,
              outPortPeople: this.outPort,
              startTime: this.enterPortDate || '',
              endTime: this.outPortDate || '',
              state: this.state,
              rows: this.size,
              page: this.page,
            },
          );
        }
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 改变每页条数时触发事件
      contractSizeChange(sizes) {
        this.size = sizes;
        this._vehicleDeployInfoCvPortList();
      },
      // 改变当前页时触发事件
      contractCurrentChange(page) {
        this.page = page;
        this._vehicleDeployInfoCvPortList();
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._vehicleDeployInfoCvPortList();
      },
      // 重置
      resetBtn() {
        this.port = '';
        this.awbIpt = '';
        this.batchIpt = '';
        this.chassisIpt = '';
        this.unitIpt = '';
        this.brandIpt = '';
        this.enterPort = '';
        this.outPort = '';
        this.enterPortDate = '';
        this.outPortDate = '';
        this.state = '';
      },
      // 模板下载
      downLoad() {
        window.location.href = '/file/集港管理模板.xlsx';
      },
      // 表格导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._vehicleDeployInfoCvPortList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._vehicleDeployInfoCvPortList();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      // 时间格式
      getTime(time) {
        if (typeof (time) == 'string') {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii');
        } else {
          return '';
        }
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'chassisIpt':
            this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        let url = `${baseUrl}` + '/platform/portFocusManage/exportExcel'+'?access_token=' + token;
        window.exportExcel(url, {
          portName: this.port,
          waybillNo: this.awbIpt,
          batchNumber: this.batchIpt,
          frameNumber: this.chassisIpt,
          brandName: this.brandIpt,
          enterPortPeople: this.enterPort,
          outPortPeople: this.outPort,
          startTime: this.enterPortDate || '',
          endTime: this.outPortDate  || '',
          state: this.state,
          rows: this.size,
          page: this.page,
        }, '集港管理表');
        // window.location.href = `${baseUrl}/platform/portFocusManage/exportExcel?access_token=${token}&portName=${this.port}&waybillNo=${this.awbIpt}&batchNumber=${this.batchIpt}&frameNumber=${this.chassisIpt}&brandName=${this.brandIpt}&enterPortPeople=${this.enterPort}&outPortPeople=${this.outPort}&enterPortDate=${this.enterPortDate || ''}&outPortDate=${this.outPortDate || ''}&state=${this.state}`;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      .navContainer p {
        display: inline-block;
        width: 90px;
        text-align: right;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        .tableContainerNav {
          text-align: right;
          color: rgba(51, 136, 255, 1);

          span {
            display: inline-block;
            font-size: 16px;
            text-decoration: underline;

            i {
              font-size: 16px;
              text-decoration: underline;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        .stepContainer {
          margin: 10px 0 10px 20px;

          ::v-deep {
            .el-step__description.is-finish {
              color: #C0C4CC;
            }

            .el-step__description {
              color: #C0C4CC;
            }

            //.is-process{
            //  color: #C0C4CC;
            //}
          }
        }

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      height: 400px;
      padding: 20px 10px;
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
